import {
  ElementCheckboxIcon,
  ElementRadioIcon,
  ElementSelectIcon,
  ElementreCAPTCHAIcon,
  EmailIcon,
  FieldNumberIcon,
  FieldTextIcon,
  KeyIcon,
  PhoneIcon,
  UploadIcon,
} from '@packages/systems/spring';

export const SCHEMA_ICON_MAP = {
  Plain: FieldTextIcon,
  Phone: PhoneIcon,
  Password: KeyIcon,
  Number: FieldNumberIcon,
  Email: EmailIcon,
  Radio: ElementRadioIcon,
  Checkbox: ElementCheckboxIcon,
  Select: ElementSelectIcon,
  ReCaptcha: ElementreCAPTCHAIcon,
  File: UploadIcon,
};
